export enum Events {
  onShowMenuItem = "onShowMenuItem",
  onLogin = "onLogin",
  onAlert = "onAlert",
  loadingChange = "loadingChange"
}
